<template>
  <section class="table by4">
    <ul>
      <li><label>LOI</label><label>NBR</label><label>PRIX</label><label>P.C</label></li>
    </ul>
    <ul>
      <li v-for="(p) in programs" :value="p" :key="p">
        <span v-if="reservsbyProg[p-1].length"><i class="badge">{{ programName(p-1) }}</i></span>
        <span v-if="reservsbyProg[p-1].length">{{reservsbyProg[p-1].length}}</span>
        <span v-if="reservsbyProg[p-1].length">{{price[p-1] | euros }}</span>
        <span v-if="reservsbyProg[p-1].length">{{ percentPrice[p-1] }}%</span>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'StatisticsProgramProg',
  props: {
    customReservations: Array,
    listPrograms: Array,
    tva: Boolean
  },
  data () {
    return {
    }
  },
  computed: {
    reservs: function () {
      return this.customReservations.filter(r => r.status > 1)
    },
    programs: function () {
      return this.listPrograms.length + 1
    },
    total: function () {
      var total = 0
      this.reservs.forEach(r => {
        if (this.tva) total = total + r.lot.calculatedprice
        else total = total + r.lot.actedprice
      })
      return total
    },
    quantity: function () {
      var quantity = []
      for (let i = 0; i < this.programs; i++) {
        quantity.push(this.reservs.filter(r => Number(r.program.numero) === i).length)
      }
      return quantity
    },
    reservsbyProg: function () {
      var reservsbyProg = []
      for (let i = 0; i < this.programs; i++) {
        reservsbyProg.push(this.reservs.filter(r => Number(r.program.numero) === i))
      }
      return reservsbyProg
    },
    price: function () {
      var price = []
      this.reservsbyProg.forEach(q => {
        if (q.length > 0) {
          var calc = 0
          q.forEach(r => {
            if (this.tva) calc = calc + r.lot.calculatedprice
            else calc = calc + r.lot.actedprice
          })
          price.push(calc)
        } else price.push(0)
      })
      return price
    },
    percent: function () {
      var percent = []
      this.quantity.forEach(q => {
        percent.push(Number(((q / this.reservs.length) * 100).toFixed(2)))
      })
      if (percent.length < 1) return ''
      return percent
    },
    percentPrice: function () {
      var percentPrice = []
      this.price.forEach(p => {
        percentPrice.push(Number(((p / this.total) * 100).toFixed(2)))
      })
      return percentPrice
    }
  },
  methods: {
    programName: function (i) {
      return this.listPrograms.find(p => p.numero === i).shortname
    }
  }
}
</script>
